import Button from "@app/components/button"
import GradientContainer from "@app/components/gradient/gradient-container"
import TextGradient from "@app/components/gradient/gradient-text"
import { useState } from "react";

const MobileRetailGrocery = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="px-8 pt-8 pb-4">
      <div>
        <div className="flex flex-col space-y-5 ">
          <TextGradient>
            <span className="h2">01</span>
          </TextGradient>
          <p className="mobile-h3 2xs:mobile-h2 text-background-primary-dark">Retail & grocery</p>
          <GradientContainer overrideClassName="w-[30%] h-2" />
          <div className="text-text-color-mid-em-light space-y-5">
            <p>
              SimpleWaste represents all sectors of the retail industry.
            </p>
            <p>
              Our unique service and technology platform are ideal for retail, storefronts, grocery, and convenience stores!
              Your various waste and recycling profiles are seamlessly managed through our technology portal.
            </p>
            {isExpanded &&
              <div className="space-y-5">
                <p>
                  Unlock ease-of-use functionality when it comes to administration, procurement, and ongoing operations support.
                </p>
                <p>
                  Find the best pricing options for your represented regions through our automated RFP Optimization Tool.
                </p>
              </div>
            }
          </div>
          <div>
            <Button onClick={() => setIsExpanded(!isExpanded)}>
              {isExpanded ? 'Read less' : 'Read more'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileRetailGrocery;